import { gql } from '@apollo/client'

/** 充值预结算 */
export const RECHARGE_BALANCE = gql`
  mutation rechargeBalance($param: RechargeInput) {
    orderModule {
      copyrightRechargeBalance(param: $param) {
        needPay
        orderId
        orderNo
        payInfo
        payType
      }
    }
  }
`

/** 积分订单结果 */
export const GET_RECHARGE_RESULT = gql`
  query getRechargeResult($id: Long, $orderNo: String) {
    orderModule {
      status: copyrightRechargeResult(id: $id, orderNo: $orderNo)
    }
  }
`

/** 获取充值金额对应额积分 */
export const GET_RECHARGE_POINT = gql`
  query getRechargePoint($amount: Long) {
    point: preIntegralRechargeAmount(totalFee: $amount)
  }
`

/** 获取支持的支付方式 */
export const GET_PAY_TYPE_LIST = gql`
  query getPayTypeList($payScene: PayScene = ACCOUNT_SPLITTING) {
    settlementModule {
      payTypeList(payScene: $payScene) {
        available
        icon
        name
        payChannel
        type
        payProvider
      }
    }
  }
`
